import { Select, Empty } from "antd";
import { ImSpinner2 } from "react-icons/im";
import { useCourseProgress } from "./hooks/useCourseProgress.js";

const { Option } = Select;

function CourseProgress() {
  const {
    courses,
    coursesLoading,
    selectedCourseId,
    handleCourseChange,
    progressData,
    progressLoading,
    weeklyChartCanvas,
    completionChartCanvas,
    formatTime,
  } = useCourseProgress();
  console.log('Courses', courses);
  console.log(typeof courses);



  return (
    <main className="ml-progress-content">
      {coursesLoading ? (
        <div style={{ minHeight: "inherit" }} className="d-flex justify-content-center align-items-center">
          <ImSpinner2 size={25} className="btn-spinner" />
        </div>
      ) : courses.length === 0 ? (
        <div style={{ padding: "60px 0" }}>
          <Empty description="You haven't enrolled in any courses yet" />
        </div>
      ) : (
        <>
          <p className="lead mt-3" style={{ fontWeight: "bold" }}>
            Course Progress
          </p>

          <div className="course-selector">
            <Select
              id="course-select"
              value={selectedCourseId || undefined}
              onChange={handleCourseChange}
              className="dropdown"
            >
              {courses.map((course) => (
                <Option key={course.course_id} value={course.course_id}>
                  {course.title}
                </Option>
              ))}
            </Select>
          </div>

          <div className="progress-content mt-4">
            {progressLoading ? (
              <div style={{ padding: "40px 0" }} className="d-flex justify-content-center align-items-center">
                <ImSpinner2 size={25} className="btn-spinner" />
              </div>
            ) : !progressData ? (
              <div style={{ padding: "40px 0" }}>
                <Empty description="No progress data available for this course" />
              </div>
            ) : (
              <>
                <div className="progress-summary">
                  <div className="summary-card">
                    <h3>Total Learning Time</h3>
                    <div className="metric">{formatTime(progressData.totalLearningTime * 60)}</div>
                    <div className="trend up">Course learning time</div>
                  </div>

                  <div className="summary-card">
                    <h3>Lessons Completed</h3>
                    <div className="metric">
                      {progressData.completedLessons}/
                      {courses.find((course) => course.course_id === selectedCourseId)?.number_of_lessons || 0}
                    </div>
                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{
                          width: `${(progressData.completedLessons /
                              (courses.find((course) => course.course_id === selectedCourseId)?.number_of_lessons ||
                                1)) *
                            100
                            }%`,
                        }}
                      ></div>
                    </div>
                  </div>

                  <div className="summary-card">
                    <h3>Active Days This Month</h3>
                    <div className="metric">{progressData.activeDaysThisMonth.length} days</div>
                    <div className="streak-calendar">
                      {Array.from({ length: 31 }, (_, i) => {
                        const day = i + 1;
                        const date = new Date();
                        date.setDate(day);
                        const isActive = progressData.activeDaysThisMonth.some(
                          (activeDate) => new Date(activeDate).toDateString() === date.toDateString()
                        );

                        return (
                          <div key={day} className={`streak-day ${isActive ? "day-active" : ""}`}>
                            {day}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div className="progress-charts">
                  <div className="chart-container">
                    <h3>Weekly Activity</h3>
                    <canvas ref={weeklyChartCanvas} id="weekly-chart"></canvas>
                  </div>

                  <div className="chart-container">
                    <h3>Completion Progress</h3>
                    <div className="completion-chart-wrap">
                      <canvas ref={completionChartCanvas} id="completion-chart"></canvas>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </main>
  );
}

export default CourseProgress;